/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import styled from "react-emotion";
import axios from "axios";
import { Dropdown, Spin, Icon, Checkbox, Menu } from "antd";
import { isValidSize, getImageInfo } from "../../../utils/helpers";
import CroppingModal from "./CroppingModal";
import { inherits } from "util";

// ------------------------------------------------------ Styles -------------------------
const ImageCardContainer = styled("div")(props => ({
  width: "130px",
  height: "140px",
  margin: "0px 10px 5px 0px",
  padding: "1px",
  textAlign: "center",
  border: props.isValid
    ? props.checked
      ? "1px solid #1c8df7"
      : "1px solid #a9a9a9"
    : "1px solid #c53929",
  borderRadius: "5px",
  position: "relative",
  ":hover": {
    cursor: "pointer",
    boxShadow: "inset 0 0 2px #000000",
    ".image-info": {
      display: "none"
    },
    a: {
      display: "block",
      marginTop: "5px",
      fontSize: "12px",
      fontWeight: "bold"
    },
    ".checkBox-wrapper": {
      visibility: props.checked ? "visible" : "hidden"
    }
  },
  a: {
    display: "none",
    textAlign: "center"
  }
}));

const ImageCardWrapper = styled("div")({
  maxHeight: "110px",
  maxWidth: "210px",
  minWidth: "110px",
  height: "110px",
  overflow: "hidden"
});

const ImageCard = styled("div")({
  position: "relative",
  img: {
    width: "initial",
    height: "-webkit-fill-available"
  }
});

const CheckBoxWrapper = styled("div")(props => ({
  position: "absolute",
  right: 0,
  top: -2,
  zIndex: 1,
  visibility: props.checked ? "visible" : "hidden"
}));

const ImageInfo = styled("p")(props => ({
  marginTop: "5px",
  fontSize: "12px",
  fontWeight: "bold",
  color: props.error ? "#c53929" : inherits
}));

const ErrorMessage = styled("p")({
  marginTop: "45px",
  color: "#c53929"
});
// ---------------------------------------------------------------------------------------
class Image extends Component {
  state = {
    width: "",
    height: "",
    type: "",
    croppingModalVisibility: false,
    croppingMode: "",
    selectedImageForCropping: {},
    isValid: true,
    isValidImage: true
  };

  componentDidMount() {
    const { image } = this.props;
    getImageInfo(image).then(res => {
      this.setState({
        width: res.width,
        height: res.height,
        isValid: isValidSize(
          { name: "logo", shape: "square" },
          res.width,
          res.height
        ),
        isValidImage: isValidSize(
          { name: "image", shape: "landscape" },
          res.width,
          res.height
        )
      });
    });
  }

  renderMenu = image => {
    const { isValid, isValidImage } = this.state;
    return (
      <Menu onClick={e => this.handleMenuClick(e, image)}>
        <Menu.Item
          key="image"
          title={
            isValidImage
              ? "Your image will be cropped to fit all required ratios"
              : "Invalid Image dimension"
          }
          disabled={!isValidImage}
        >
          Image
        </Menu.Item>
        <Menu.Item
          key="logo"
          title={
            isValid
              ? "Your logo will be cropped to fit all required ratios"
              : "Invalid Logo dimension"
          }
          disabled={!isValid}
        >
          Logo
        </Menu.Item>
      </Menu>
    );
  };

  onChange = () => {
    const { image } = this.props;
    this.props.onChecked(image.uid);
  };

  handleMenuClick = (e, image) => {
    if (/^http(s?):\/\//.test(image.url)) {
      axios
        .get(
          `https://us-central1-cogni-ga-health.cloudfunctions.net/get_base64_image?url=${image.url}`
        )
        .then(res => {
          image.url = res.data;
          this.setState({
            croppingModalVisibility: true,
            croppingMode: e.key,
            selectedImageForCropping: image
          });
        });
    } else {
      this.setState({
        croppingModalVisibility: true,
        croppingMode: e.key,
        selectedImageForCropping: image
      });
    }
  };

  handleCancel = () => {
    this.setState({
      croppingModalVisibility: false
    });
  };

  renderCroppingModal = () => {
    if (this.state.croppingModalVisibility) {
      const {
        croppingModalVisibility,
        croppingMode,
        selectedImageForCropping
      } = this.state;
      return (
        <CroppingModal
          visibility={croppingModalVisibility}
          onCancel={this.handleCancel}
          croppingMode={croppingMode}
          image={selectedImageForCropping}
        />
      );
    } else return null;
  };

  render() {
    const { image } = this.props;
    const { width, height, isValid } = this.state;
    return (
      <div>
        {width ? (
          <ImageCardContainer checked={image.isCropped} isValid={isValid}>
            <CheckBoxWrapper
              className="checkBox-wrapper"
              checked={image.isCropped}
            >
              <Checkbox
                checked={image.isCropped}
                onChange={this.onChange}
              ></Checkbox>
            </CheckBoxWrapper>
            <ImageCardWrapper>
              <ImageCard>
                {isValid ? (
                  <img src={image.url} alt="upload" />
                ) : (
                  <ErrorMessage>Invalid Image dimension</ErrorMessage>
                )}
              </ImageCard>
            </ImageCardWrapper>
            <ImageInfo error={!isValid} className="image-info">
              {width} x {height}
            </ImageInfo>
            {isValid ? (
              <Dropdown overlay={this.renderMenu(image)}>
                <a className="ant-dropdown-link" href="#">
                  Use as <Icon type="down" />
                </a>
              </Dropdown>
            ) : null}
          </ImageCardContainer>
        ) : (
          <Spin
            indicator={
              <Icon
                type="loading"
                style={{ fontSize: 24, margin: "50px" }}
                spin
              />
            }
          />
        )}
        {this.renderCroppingModal()}
      </div>
    );
  }
}

export default Image;
